module.exports = __webpack_public_path__ + "media/flags/pm-68eb0617.svg";